import { render, staticRenderFns } from "./DuplicateBreakdown.vue?vue&type=template&id=37a05000&scoped=true&"
import script from "./DuplicateBreakdown.vue?vue&type=script&lang=js&"
export * from "./DuplicateBreakdown.vue?vue&type=script&lang=js&"
import style0 from "./DuplicateBreakdown.vue?vue&type=style&index=0&id=37a05000&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37a05000",
  null
  
)

export default component.exports